module.exports = __webpack_public_path__ + "static/media/12.fec8f765.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/12.png
// module id = 1222
// module chunks = 0